<template>
  <div class="crud_module--app_config">
    <div class="inner-wrap">
      <textarea v-model="datas">

      </textarea>
      <el-button type="primary" @click="update">{{ $t("button.confirm") }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  methods: {
    async getAppConfig() {
      await this.$axios.get(`/app_config`, {
        params: {}
      }).then(res=>{
        console.log(res);
        delete res.data.mysqlConfig;
        this.datas = JSON.stringify(res.data, undefined, 4);

      }).catch(err=>{ return false; });
    },
    async update() {
      try {
        var obj = JSON.parse(this.datas);
        let valid = await this.$axios.post(`/app_config`, {
          ...obj,
        }).then(res=>{
          return true;
        }).catch(err=>{
          console.log(err?.response?.data);
          this.$message({
            message: this.$t("error.generic"),
            type: 'error'
          });
          return false;
        });
      } catch (error) {
        this.$message({
          message: error,
          type: 'error'
        });
      }
      
    },
  },
  created() {
    this.getAppConfig();
  },
  data() {
    return {
      datas: ""
    }
  }
}
</script>

<style lang="scss">
.crud_module--app_config{
  width: 70vw;
  .inner-wrap{
    textarea{
      width: 100%;
      height: 500px;
    }
  }
}
</style>